<template>
  <div
    class="bg-gradient-to-t from-interactive-primary/25 to-interactive-primary/0 border border-border-line md:grid md:grid-rows-[max-content_1fr]">
    <h3 class="text-subtitle4 border-b border-border-line p-4 md:px-6">CopyTrade now</h3>
    <div class="p-4 md:p-6 md:grid md:grid-rows-[max-content_1fr]">
      <dl class="grid grid-cols-2 auto-rows-max gap-x-4 gap-y-4 text-body1">
        <dt class="text-left whitespace-nowrap">
          Users copying this trader
        </dt>
        <dd class="text-right flex items-center justify-end">
          <p>144<span style="color: #FFF; opacity: 0.5;">/200</span></p>
        </dd>
        <dt class="text-body1 text-t-primary text-left">Referral code</dt>
        <dd class="text-end text-body1 dark:text-interactive-primary text-t-link flex items-center justify-end gap-1">
          <button @click="copyCode" type="button" class="text-t-third hover:text-t-primary">
            <p class="text-t-primary">{{ referralCode || 'ECHOCAPITAL' }}</p>
            <span class="sr-only">Copy invite code to clipboard</span>
          </button>
        </dd>
        <dt class="text-body1 text-t-primary text-left">Referral link</dt>
        <dd
          class="text-end text-body1 dark:text-interactive-primary text-t-link grid grid-cols-[1fr_max-content] gap-1">
          <a :href="referralLink || '.'" class="block max-h-6 text-end overflow-hidden text-ellipsis">
            <span class="text-t-third">{{ referralLink || '--' }}</span>
          </a>
          <button @click="copyLink" type="button" class="text-t-third hover:text-t-primary">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M16.5 17.5V3.5H4.5V17.5H16.5ZM15.5 16.5H5.5V4.5H15.5V16.5ZM19.5 20.5V6H18.5V19.5H7V20.5H19.5Z"
                fill="currentColor"></path>
            </svg>
            <span class="sr-only">Copy invite link to clipboard</span>
          </button>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingPageInviteNowSection',
  props: {
    referralCode: {
      type: String,
      default: 'ECHOCAPITAL'
    },
    referralLink: {
      type: String,
      default: ''
    }
  },
  methods: {
    async copyCode() {
      try {
        await navigator.clipboard.writeText(this.referralCode || 'ECHOCAPITAL')
      } catch (error) {
        console.error('Ошибка копирования:', error)
        const textArea = document.createElement('textarea')
        textArea.value = this.referralCode || 'ECHOCAPITAL'
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
      }
    },
    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.referralLink || window.location.href)
      } catch (error) {
        console.error('Ошибка копирования:', error)
        const textArea = document.createElement('textarea')
        textArea.value = this.referralLink || window.location.href
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
      }
    }
  }
}
</script>

<style scoped>
/* Все стили будут добавлены через глобальные CSS файлы */
</style>

